import { Modal, Box, IconButton, Button, Typography } from '@mui/material';
import { Close, Settings } from '@mui/icons-material';
import { POPULATION_SIZE } from '../../config/constants';

interface HelpModalProps {
  open: boolean;
  onClose: () => void;
  onGetStarted?: () => void;
  openUserModal: () => void;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  maxWidth: '600px',
  bgcolor: 'WhiteSmoke',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  outline: 'none',
} as const;

const closeButtonStyle = {
  position: 'absolute',
  top: '5px',
  right: '5px',
} as const;

const centerStyle = {
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '16px',
} as const;

const paragraphStyle = {
  marginBottom: '0.5em',
} as const;

export default function HelpModal({
  open,
  onClose,
  onGetStarted,
  openUserModal,
}: HelpModalProps) {

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h5" component="h3" sx={{ mb: 2 }}>
          How to use <strong>unprompted</strong>
        </Typography>

        <Typography sx={paragraphStyle}>
          Initially, {POPULATION_SIZE} images are made from random prompts using DALL-E.
        </Typography>

        <Typography sx={paragraphStyle}>
          You select your favourite 2-{POPULATION_SIZE - 1} images by clicking on them or using the <kbd>Left-Arrow</kbd>, <kbd>Right-Arrow</kbd> and <kbd>Space</kbd> keys.
        </Typography>

        <Typography sx={paragraphStyle}>
          When you click
          <Button
            disabled
            sx={{ fontWeight: 'bold', py: '0px' }}
          >
            Generate images
          </Button>
          or press the <kbd>Enter</kbd> key, new prompts and images will be bred from the ones you selected.
        </Typography>

        <Typography sx={paragraphStyle}>
          Repeat until you are happy with your images!
        </Typography>

        <Box sx={centerStyle}>
          {onGetStarted ?
            <Button
              onClick={onGetStarted}
            >
              Get started!
            </Button>
            :
            <Button
              onClick={onClose}
            >
              Got it!
            </Button>
          }
        </Box>
        {onGetStarted ?
	  <IconButton size="small" sx={closeButtonStyle} onClick={openUserModal}>
            <Settings />
          </IconButton>
         : <IconButton size="small" sx={closeButtonStyle} onClick={onClose}>
            <Close />
          </IconButton>
        }
      </Box>
    </Modal>
  );
}
